import { Link } from "react-router-dom";

export const CWS_URL = "https://chromewebstore.google.com/detail/glosslink/pjfeijggadjjnciaoppapehckfjeogod";

export const SiteNav = ({ right }) => (
  <nav className="sticky top-0 z-40 bg-white/90 backdrop-blur border-b border-slate-200">
    <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between gap-4">
      <Link to="/" className="flex items-center gap-2 font-extrabold text-2xl tracking-tight" data-testid="packs-nav-logo"><span className="text-2xl">📒</span> GlossLink</Link>
      <div className="flex items-center gap-5 text-sm">
        <Link to="/for-nurses" className="hidden sm:inline text-slate-700 hover:text-blue-700" data-testid="packs-nav-nurses">For nurses</Link>
        <Link to="/packs" className="font-semibold text-blue-700" data-testid="packs-nav-packs">Gloss Packs</Link>
        {right || (
          <a href={CWS_URL} target="_blank" rel="noopener noreferrer" className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-semibold" data-testid="packs-nav-install">Add to Chrome</a>
        )}
      </div>
    </div>
  </nav>
);

export const SiteFooter = () => (
  <footer className="border-t border-slate-200 mt-20 py-10 bg-white">
    <div className="max-w-6xl mx-auto px-6 flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-slate-500">
      <div>© {new Date().getFullYear()} GlossLink. Gloss Packs are included with GlossLink — no extra charge.</div>
      <div className="flex gap-6">
        <Link to="/privacy" className="hover:text-blue-600">Privacy</Link>
        <a href="mailto:support@glosslink.app" className="hover:text-blue-600">Support</a>
        <Link to="/admin/login" className="hover:text-blue-600" data-testid="footer-pack-studio-link">Pack Studio</Link>
      </div>
    </div>
  </footer>
);
